import iconecuador from "../assets/ecuador.png";
import iconbolivia from "../assets/bolivia.png";
import iconchile from "../assets/chile.png";

import imagenTumbes from "../assets/tumbes.jpeg";
import imagenTacna from "../assets/tacna.jpeg";
import imagenPuno from "../assets/puno.jpeg";
import imagenArequipa from "../assets/arequipa.jpeg";
import mapatumbes from "../assets/mapa_tumbes.png";
import mapatacna from "../assets/mapa_tacna.png";
import mapapuno from "../assets/mapa_puno.png";
import mapaarequipa from "../assets/mapa_arequipa.png";

import ModalDestino from "../components/ModalDestino";
import ModalRegistroMiembro from "../components/ModalRegistroMiembro";
import Testimonios from "../components/Testimonios";
import bootcamp from "../assets/bootcamp.jpeg";
import preguntas from "../assets/preguntas.jpeg";
import padres from "../assets/padres.jpeg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const destinos = [
  {
    ciudad: "TUMBES",
    imagen: imagenTumbes,
    descripcion: "Con expedición a Ecuador",
    icon: iconecuador,

    modal: {
      titulo: "Proyecto Tumbes",

      contenido: (
        <>
          <div className="container-fluid">
            <div className="row align-items-start">
              {/* TEXTO */}
              <div className="col-lg-7">
                <p>
                  <strong>FECHAS:</strong> Del 22 de enero al 10 de febrero.
                </p>

                <p>
                  <strong>Tipo de Proyecto:</strong> Evangelismo y Construcción.
                </p>

                <p>
                  <strong>Ubicación:</strong> Extremo noroeste del Perú.
                </p>

                <p>
                  <strong>Expedición:</strong> Evangelismo por una semana en el
                  país de Ecuador.
                </p>

                <p>
                  <strong>Costo:</strong> S/ 450.00. Precio Regular hasta el 11 de
                  Diciembre del 2026.
                </p>
              </div>

              {/* IMAGEN */}
              <div className="col-lg-5 text-center">
                <img
                  src={mapatumbes}
                  alt="Proyecto Tumbes"
                  className="img-fluid  imagen-proyecto"
                />
              </div>

              <p>
                Tumbes es un departamento que destaca por su clima tropical, su
                biodiversidad de manglares y sus playas. Su gente tiene una
                identidad alegre y desarrolla actividades relacionadas con la
                pesca, artesanía y otros ámbitos.
              </p>

              <p>
                También posee importancia histórica como puerta de la conquista
                española y limita con el Océano Pacífico y la República de
                Ecuador.
              </p>

              <p>
                <strong>Ministerio:</strong> Cada equipo participará en diversos
                proyectos. En Teen Missions Perú, nos esforzamos por brindar a
                nuestros equipos una experiencia ministerial variada.
              </p>

              <p>
                Lo logramos mediante evangelización personal, reuniones al aire
                libre, evangelismo de persona a persona, ministerio infantil,
                proyectos de servicio, teatros, títeres, música y proyectos de
                construcción.
              </p>

              <p>
                Los proyectos para cada equipo están sujetos a cambios según las
                necesidades de la iglesia u organización cristiana que recibe al
                equipo.
              </p>

              <p>
                ¡Queremos que nuestros equipos tengan espíritu de servicio y
                aprovechen las oportunidades que se les presente!
              </p>
            </div>
          </div>
        </>
      ),
    },
  },

  {
    ciudad: "TACNA",
    imagen: imagenTacna,
    descripcion: "Con expedición a Chile",
    icon: iconchile,

    modal: {
      titulo: "Proyecto Tacna",

      contenido: (
        <>
          <div className="container-fluid">
            <div className="row align-items-start">
              {/* TEXTO */}
              <div className="col-lg-7">
                <p>
                  <strong>FECHAS:</strong> Del 22 de enero al 10 de febrero.
                </p>

                <p>
                  <strong>Tipo de Proyecto:</strong> Evangelismo y Construcción.
                </p>

                <p>
                  <strong>Ubicación:</strong> Extremo sur del Perú.
                </p>

                <p>
                  <strong>Expedición:</strong> Evangelismo por una semana en el
                  país de Chile.
                </p>

                <p>
                  <strong>Costo:</strong> S/ 450.00. Precio Regular hasta el 11 de
                  Diciembre del 2026.
                </p>
              </div>
              <div className="col-lg-5 text-center">
                <img
                  src={mapatacna}
                  alt="Proyecto Tacna"
                  className="img-fluid  imagen-proyecto"
                />
              </div>
              <p>
                Tacna es una bella región y tiene un gran valor comercial y
                turístico. Es conocida como la Ciudad Heroica y destaca por su
                profunda identidad patriótica.
              </p>

              <p>
                Su territorio cruza desde la árida costa del desierto hasta las
                altas cumbres de la cordillera de los Andes. Posee un clima
                templado, seco y con sol casi todo el año.
              </p>

              <p>
                Entre sus atractivos naturales destacan los Petroglifos de
                Miculla, con arte rupestre milenario.
              </p>

              <p>
                <strong>Ministerio:</strong> Cada equipo participará en diversos
                proyectos. En Teen Missions Perú, nos esforzamos por brindar a
                nuestros equipos una experiencia ministerial variada.
              </p>

              <p>
                Lo logramos mediante evangelización personal, reuniones al aire
                libre, evangelismo de persona a persona, ministerio infantil,
                proyectos de servicio, teatros, títeres, música y proyectos de
                construcción.
              </p>

              <p>
                Los proyectos para cada equipo están sujetos a cambios según las
                necesidades de la iglesia u organización cristiana que recibe al
                equipo.
              </p>

              <p>
                ¡Queremos que nuestros equipos tengan espíritu de servicio y
                aprovechen las oportunidades que se les presente!
              </p>
            </div>
          </div>
        </>
      ),
    },
  },

  {
    ciudad: "PUNO",
    imagen: imagenPuno,
    descripcion: "Con expedición a Bolivia.",
    icon: iconbolivia,

    modal: {
      titulo: "Proyecto Puno",

      contenido: (
        <>
          <div className="container-fluid">
            <div className="row align-items-start">
              {/* TEXTO */}
              <div className="col-lg-7">
                <p>
                  <strong>FECHAS:</strong> Del 22 de enero al 10 de febrero.
                </p>

                <p>
                  <strong>Tipo de Proyecto:</strong> Evangelismo y Construcción.
                </p>

                <p>
                  <strong>Ubicación:</strong> En el sureste del Perú.
                </p>

                <p>
                  <strong>Expedición:</strong> Evangelismo por una semana en el
                  país de Bolivia.
                </p>

                <p>
                  <strong>Costo:</strong> S/ 450.00. Precio Regular hasta el 11 de
                  Diciembre del 2026.
                </p>
              </div>
              <div className="col-lg-5 text-center">
                <img
                  src={mapapuno}
                  alt="Proyecto Puno"
                  className="img-fluid  imagen-proyecto"
                />
              </div>

              <p>
                Puno es una hermosa ciudad, ubicada en la meseta del Collao a
                orillas del majestuoso Lago Titicaca.
              </p>

              <p>
                Se destaca por ser la Capital del Folclore Peruano, poseer una
                geografía de fría altura andina y albergar un valioso legado
                histórico prehispánico y colonial.
              </p>

              <p>
                También cuenta con comunidades tradicionales que preservan
                técnicas ancestrales de vida sobre totora y tejido a mano.
              </p>

              <p>
                <strong>Ministerio:</strong> Cada equipo participará en diversos
                proyectos. En Teen Missions Perú, nos esforzamos por brindar a
                nuestros equipos una experiencia ministerial variada.
              </p>

              <p>
                Lo logramos mediante evangelización personal, reuniones al aire
                libre, evangelismo de persona a persona, ministerio infantil,
                proyectos de servicio, teatros, títeres, música y proyectos de
                construcción.
              </p>

              <p>
                Los proyectos para cada equipo están sujetos a cambios según las
                necesidades de la iglesia u organización cristiana que recibe al
                equipo.
              </p>

              <p>
                ¡Queremos que nuestros equipos tengan espíritu de servicio y
                aprovechen las oportunidades que se les presente!
              </p>
            </div>
          </div>
        </>
      ),
    },
  },

  {
    ciudad: "AREQUIPA",
    imagen: imagenArequipa,
    descripcion: "",
    modal: {
      titulo: "Proyecto Arequipa",
      contenido: (
        <>
          <div className="container-fluid">
            <div className="row align-items-start">
              {/* TEXTO */}
              <div className="col-lg-7">
                <p>
                  <strong>FECHAS:</strong> Del 22 de enero al 10 de febrero.
                </p>

                <p>
                  <strong>Tipo de Proyecto:</strong> Evangelismo y Construcción.
                </p>

                <p>
                  <strong>Ubicación:</strong> Sur-occidental de la costa y
                  sierra del Perú.
                </p>

                <p>
                  <strong>Costo:</strong> S/ 425.00. Precio Regular hasta el 11 de
                  Diciembre del 2026.
                </p>
              </div>
              <div className="col-lg-5 text-center">
                <img
                  src={mapaarequipa}
                  alt="Proyecto Arequipa"
                  className="img-fluid  imagen-proyecto"
                />
              </div>
              <p>
                Arequipa es una hermosa ciudad del sur del Perú, la segunda
                región más poblada del país, conocida como la Ciudad Blanca por
                sus construcciones de sillar. Destaca por su geografía de
                volcanes, su gran historia colonial, su rica cultura y sus
                bellos lugares turísticos.
              </p>

              <p>
                <strong>Ministerio:</strong> Cada equipo participará en diversos
                proyectos. En Teen Missions Perú, nos esforzamos por brindar a
                nuestros equipos una experiencia ministerial variada.
              </p>

              <p>
                Lo logramos mediante evangelización personal, reuniones al aire
                libre, evangelismo de persona a persona, ministerio infantil,
                proyectos de servicio, teatros, títeres, música y proyectos de
                construcción.
              </p>

              <p>
                Los proyectos para cada equipo están sujetos a cambios según las
                necesidades de la iglesia u organización cristiana que recibe al
                equipo.
              </p>

              <p>
                ¡Queremos que nuestros equipos tengan espíritu de servicio y
                aprovechen las oportunidades que se les presente!
              </p>
            </div>
          </div>
        </>
      ),
    },
  },
];

export default function Viajes() {
  // ==============================
  // ESTADOS DE LOS MODALES
  // ==============================
  const navigate = useNavigate();
  const location = useLocation();
  const [mostrarRegistroMiembro, setMostrarRegistroMiembro] = useState(false);
  const [destinoSeleccionado, setDestinoSeleccionado] = useState(null);

  useEffect(() => {
    if (location.pathname === "/viajes/registro-miembro") {
      setMostrarRegistroMiembro(true);
    }
  }, [location.pathname]);

  return (
    <>
      {/* ==============================
          CONTENIDO DE VIAJES
      ============================== */}

      <div className="pagina-viajes">
        {/* RELIEVE */}

        <div className="relieve-overlay"></div>

        {/* ==============================
            HERO
        ============================== */}

        <section
          className="hero-viajes"
          style={{
            backgroundImage:
              "url('https://thumbs-us-east-1.myalbum.io/photo/1k0/f8522c08-6a60-4c59-989a-6006b7ed6e35.jpg')",
          }}
        >
          <div className="hero-overlay-viajes">
            <div className="hero-watermark"></div>

            <div className="container position-relative">
              <h1 className="display-2 fw-bold titulo-viajes">Viajes 2027</h1>

              <p className="hero-subtitle-viajes subtitulo-viajes">
                Descubre nuevos lugares y experiencias, compartiendo el mensaje
                de salvación.
              </p>
            </div>
          </div>
        </section>

        {/* ==============================
            DESTINOS
        ============================== */}

        <section className="p-0">
          {/* TESTIMONIOS */}

          <Testimonios />

          {/* CIUDADES */}
          <h2 className="text-white fw-bold text-ciudad-titulo">
            Puedes elegir el lugar donde realizarás tus practicas misioneras
          </h2>
          <br></br>
          {destinos.map((destino, index) => (
            <section key={index} className="espacios">
              {/* IMAGEN + TÍTULO + BOTÓN */}
              <div className="viaje-imagen-container">
                <img
                  src={destino.imagen}
                  alt={destino.ciudad}
                  className="viaje-img"
                />

                <div className="viaje-overlay">
                  <h2 className="text-white fw-bold text-ciudad">
                    {destino.ciudad}
                  </h2>

                  <button
                    type="button"
                    className="btn btn-viajes"
                    onClick={() => setDestinoSeleccionado(destino)}
                  >
                    Ver información
                  </button>
                </div>
              </div>

              {/* DESCRIPCIÓN */}
              <div className="container">
                <div className="d-flex justify-content-center align-items-center gap-2 py-2 text-white">
                  <span className="viaje-texto">{destino.descripcion}</span>

                  {destino.icon && (
                    <img src={destino.icon} width={50} height={50} alt="" />
                  )}
                </div>
              </div>
            </section>
          ))}
        </section>
      </div>
      <br></br>

      {/* TARJETAS A OTRAS VENTANAS */}

      <section
        className="pt-0 pb-5 m-0"
        style={{
          background:
            "linear-gradient(135deg, #44296a 0%, #370a33 100%, #0f5513 100%)",
          minHeight: "45vh",
        }}
      >
        <div className="container-fluid px-0">
          {/* 
          <h2
            className="text-center text-white fw-bold"
            style={{
              paddingTop: "60px",
              marginBottom: "40px",
            }}
          >
            Etapas del Programa
          </h2> */}

          {/* TARJETAS */}
          <div className="row g-4">
            {/* CARD 1 - BOOTCAMP */}
            <div className="col-12 col-md-4">
              <Link to="/bootcamp" className="card-enlace">
                <div className="card-valor-viajes">
                  <img
                    src={bootcamp}
                    alt="Boot Camp"
                    className="tarjeta-viajes"
                  />
                  <div className="card-valor-overlay">
                    <h5>Boot Camp</h5>
                    <br></br>
                    <p>
                      Conoce nuestro programa de entrenamiento y preparación
                      misionera.
                    </p>
                  </div>
                </div>
              </Link>
            </div>

            {/* CARD 2 - PREGUNTAS FRECUENTES */}
            <div className="col-12 col-md-4">
              <Link to="/preguntas-frecuentes" className="card-enlace">
                <div className="card-valor-viajes">
                  <img
                    src={preguntas}
                    alt="Preguntas frecuentes"
                    className="tarjeta-viajes"
                  />
                  <div className="card-valor-overlay">
                    <h5 className="preguntas">Preguntas Frecuentes</h5>
                    <br></br>
                    <br></br>
                    <br></br>
                  </div>
                </div>
              </Link>
            </div>

            {/* CARD 3 - PADRES */}
            <div className="col-12 col-md-4">
              <Link to="/padres" className="card-enlace">
                <div className="card-valor-viajes">
                  <img
                    src={padres}
                    alt="Información para padres"
                    className="tarjeta-viajes"
                  />

                  <div className="card-valor-overlay">
                    <h5>Para Padres</h5>
                    <br></br>
                    <p>
                      Información importante para padres y familiares de los
                      participantes.
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ==============================
          MODAL DESTINO
      ============================== */}

      <ModalDestino
        show={destinoSeleccionado !== null}
        destino={destinoSeleccionado}
        onClose={() => setDestinoSeleccionado(null)}
        onParticipar={() => {
          setDestinoSeleccionado(null);
          navigate("/viajes/registro-miembro");
        }}
      />

      {/* ==============================
          MODAL REGISTRO MIEMBRO
      ============================== */}

      <ModalRegistroMiembro
        show={mostrarRegistroMiembro}
        onClose={() => {
          setMostrarRegistroMiembro(false);

          if (location.pathname === "/viajes/registro-miembro") {
            navigate("/viajes");
          }
        }}
      />
    </>
  );
}
